/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/l-lin/angular-datatables/master/LICENSE
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableDirective } from './angular-datatables.directive';
import * as i0 from "@angular/core";
export var DataTablesModule = /** @class */function () {
  function DataTablesModule() {}
  DataTablesModule.forRoot = function () {
    return {
      ngModule: DataTablesModule
    };
  };
  DataTablesModule.ɵfac = function DataTablesModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DataTablesModule)();
  };
  DataTablesModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DataTablesModule
  });
  DataTablesModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return DataTablesModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTablesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [DataTableDirective],
      exports: [DataTableDirective]
    }]
  }], null, null);
})();
